import right from './right.png';
import left from './left.png';
import top from './top.png';
import bottom from './bottom.png';
import front from './front.png';
import back from './back.png';

const output = [right, left, top, bottom, front, back];
export default output;
